import React from 'react';
import * as DropdownMenu from '@radix-ui/react-dropdown-menu';
import Icon from '../icon';
import { SquareButton, ButtonProps } from '../button';

import { MenuContext } from './index';

type MenuToggleProps = ButtonProps & {
  orientation?: 'horizontal' | 'vertical';
};

const MenuToggle = ({ orientation = 'horizontal', ...props }: MenuToggleProps): React.JSX.Element => {
  const menuContext = React.use(MenuContext);

  return (
    // eslint-disable-next-line jsx-a11y/no-static-element-interactions,jsx-a11y/click-events-have-key-events
    <div
      onClick={e => {
        e.stopPropagation();
        e.preventDefault();
      }}
    >
      <DropdownMenu.Trigger asChild>
        <SquareButton
          active={menuContext.open}
          className={'menu-icon'}
          variant={'secondary-clean'}
          size={'sm'}
          aria-label={'More actions'}
          {...props}
        >
          <Icon
            variant={'inherit'}
            size={'xxl'}
            name={orientation === 'horizontal' ? 'THREE_DOTS' : 'THREE_DOTS_VERTICAL'}
          />
        </SquareButton>
      </DropdownMenu.Trigger>
    </div>
  );
};

export default MenuToggle;
